export const VARIANTS = {
    PRIMARY: 'PRIMARY',
    PRIMARY_DESTRUCTIVE: 'PRIMARY_DESTRUCTIVE',
    SECONDARY: 'SECONDARY',
    SECONDARY_DESTRUCTIVE: 'SECONDARY_DESTRUCTIVE',
};

export default {};
